export enum InvitationAction {
  COMPLETE = 'COMPLETE',
  CONFIRM = 'CONFIRM',
  GET = 'GET',
  RESEND_VERIFICATION = 'RESEND_VERIFICATION',
}
